module.exports = __webpack_public_path__ + "media/images/bg03-b4884de0055d4e17693b0f0ac89f6ad9.png";